var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeCountdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5986 14.1069L14.2581 11.9993L10.5986 9.8916V14.1069Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6273 0.75H2.37271C1.47647 0.75 0.75 1.47647 0.75 2.37271V21.6273C0.75 22.5235 1.47647 23.25 2.37271 23.25H21.6273C22.5235 23.25 23.25 22.5235 23.25 21.6273V2.37271C23.25 1.47647 22.5235 0.75 21.6273 0.75V0.75ZM19.0295 12.0115C19.0295 12.0115 19.0295 14.2931 18.7401 15.3932C18.5779 15.9954 18.1031 16.4702 17.5009 16.6323C16.4007 16.9219 12 16.9219 12 16.9219C12 16.9219 7.61079 16.9219 6.49911 16.6208C5.89692 16.4587 5.42211 15.9837 5.25989 15.3816C4.97029 14.2931 4.97029 12 4.97029 12C4.97029 12 4.97029 9.71862 5.25989 8.61844C5.42194 8.01625 5.90842 7.52977 6.49911 7.36772C7.59929 7.07812 12 7.07812 12 7.07812C12 7.07812 16.4007 7.07812 17.5009 7.37922C18.1031 7.54127 18.5779 8.01625 18.7401 8.61844C19.0412 9.71862 19.0295 12.0115 19.0295 12.0115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCountdown);
export default __webpack_public_path__ + "static/media/youtubeCountdown.985cf2d9.svg";
export { ForwardRef as ReactComponent };